// A supplier's profile picture, checked before anything is saved: the server refuses other types with
// EXTENSION_NOT_ALLOWED (NewDoor/Systems/FileItems.cs `AcceptedTypes`, pictures only here — not mp4) and an empty file
// with SINGLE_FILE. The extension is sent in lower case ("IMG_0001.JPG" as "IMG_0001.jpg"), which the server needed
// until it took any case (QA 30/09).

export const PROFILE_PICTURE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];

/** The server takes up to 200MB; a profile picture shown in the app has no reason to be larger than this. */
export const PROFILE_PICTURE_MAX_MB = 20;
const PROFILE_PICTURE_MAX_BYTES = PROFILE_PICTURE_MAX_MB * 1024 * 1024;

/** For the file input: the file dialog offers only these types (iOS converts a HEIC photo to JPEG for it). */
export const PROFILE_PICTURE_ACCEPT = PROFILE_PICTURE_EXTENSIONS.map(extension => `.${extension}`).join(',');

export const PROFILE_PICTURE_HINT = `תמונה מסוג PNG, JPG, GIF, WEBP, BMP או SVG, עד ${PROFILE_PICTURE_MAX_MB}MB`;

// A file without an extension (some sources drop it) is named after its type.
const EXTENSION_BY_MIME = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/bmp': 'bmp',
  'image/svg+xml': 'svg'
};

const splitExtension = (name = '') => {
  const match = /\.([^./\\]+)$/.exec(name);
  return match ? { base: name.slice(0, match.index), extension: match[1] } : { base: name, extension: '' };
};

/** The name to upload the file under: its extension in lower case, or one from its type when it has none. */
export const getUploadFileName = (file) => {
  const name = (file?.name || '').trim() || 'picture';
  const { base, extension } = splitExtension(name);
  if (extension) {
    return `${base}.${extension.toLowerCase()}`;
  }
  const fromType = EXTENSION_BY_MIME[(file?.type || '').toLowerCase()];
  return fromType ? `${name}.${fromType}` : name;
};

/** Why the server would refuse this picture, in Hebrew; null when it's fine. */
export const validateProfilePicture = (file) => {
  if (!file) {
    return null;
  }
  if (!file.size) {
    return 'הקובץ ריק – יש לבחור תמונה אחרת.';
  }
  const { extension } = splitExtension(getUploadFileName(file));
  if (!PROFILE_PICTURE_EXTENSIONS.includes(extension)) {
    const chosen = extension ? `קובץ מסוג ${extension.toUpperCase()} אינו נתמך. ` : '';
    return `${chosen}אפשר להעלות תמונה מסוג PNG, JPG, GIF, WEBP, BMP או SVG.`;
  }
  if (file.size > PROFILE_PICTURE_MAX_BYTES) {
    return `התמונה גדולה מדי – אפשר להעלות תמונה עד ${PROFILE_PICTURE_MAX_MB}MB.`;
  }
  return null;
};
